export const rawsLabel = 'RAW files';
export const rawsHover = 'upload raws';
export const noRawsString = 'no raws...';
export const fileSelectTitle = 'RAW video zip files';
export const emptySetTitle = 'No RAW videos';
export const emptySetDescription = 'Uploaded a zip containing all the RAW files needed to complete video edits.';
